import CkEditor from "../../components/Ckeditor/CkEditor.vue";
export default {
  components: {
    CkEditor,
  }
}